import React from 'react';

import {EMPTY_SEARCH_RESULT_PROPS} from 'notebook/mediocre/search/SearchResultProps';
import {TooltipIcon} from 'notebook/tables/constants/TableColumnConstants';

import TableAxisCell, {AxisType} from './TableAxisCell';

export interface SimpleTableAxisCellProps {
  index: number;
  // Should be either 'column' or 'row'
  dim: AxisType;
  iconPrefix?: string;
  label: string;
  // The number of rows or columns that are present
  numDims: number;
  tooltipIcons?: Array<TooltipIcon>;
  isLeftAlign: boolean;
}

/**
 * A simple TableAxisCell that does not have a ColumnConstraint.
 */
function SimpleTableAxisCell(props: SimpleTableAxisCellProps): JSX.Element {
  return (
    <TableAxisCell
      index={props.index}
      shouldHighlightCell={false}
      allowEmpty={false}
      dim={props.dim}
      disallowCustomColumns={false}
      isGhostCell={false}
      isHeaderCell={true}
      isLeftAlign={props.isLeftAlign}
      isSelected={false}
      label={props.label}
      customLabel={props.label}
      numDims={props.numDims}
      shouldDisableDeleteDim={true}
      shouldDisableInsertDimAfter={true}
      shouldDisableInsertDimBefore={true}
      showExcessLabels={false}
      tooltipIcons={props.tooltipIcons}
      locked={false}
      isTableSelected={false}
      isProtected={false}
      selectionRange={null}
      {...EMPTY_SEARCH_RESULT_PROPS}
    />
  );
}

export default SimpleTableAxisCell;
